import { mapState } from 'vuex'

export const utmParamsUtils = {
  computed: {
    ...mapState({
      utmParams: state => state.events.utmParams,
    }),
  },
  methods: {
    setUTMParamsString() {
      const utmParams = []
      Object.keys(this.utmParams).forEach(utmKey => {
        if (this.utmParams[utmKey] !== null) {
          return utmParams.push(`${utmKey}=${this.utmParams[utmKey]}`)
        }
      })
      return utmParams.length > 0 ? utmParams.join('&') : ''
    },
  },
}
